import { ERequestStatus } from '../enums/ERequestStatus';
import { ETolgeeDefault } from '../enums/ETolgeeDefault';

export const REQUEST_STATUS_OPTIONS = [
  {
    value: ERequestStatus.CANCELED,
    label: ETolgeeDefault.ENUM_REQUEST_STATUS_CANCELED
  },
  {
    value: ERequestStatus.FAILED,
    label: ETolgeeDefault.ENUM_REQUEST_STATUS_FAILED
  },
  {
    value: ERequestStatus.PENDING,
    label: ETolgeeDefault.ENUM_REQUEST_STATUS_PENDING
  },
  {
    value: ERequestStatus.PROCESSED,
    label: ETolgeeDefault.ENUM_REQUEST_STATUS_PROCESSED
  },
  {
    value: ERequestStatus.REJECTED,
    label: ETolgeeDefault.ENUM_REQUEST_STATUS_REJECTED
  }
];
